import {
  JobDetailResponse,
  ScoutJobDetailResponse,
} from '@doda/api-client/aspida/@types';
import { RELATION_LINK_LABEL } from '../../constants';
import { createOccupationLinkList } from '../createOccupationLinkList';
import { createAreaLinkList } from '../createAreaLinkList';
import { createLinkList } from '../createLinkList';
import { createIndustryLinkList } from '../createIndustryLinkList';

/**
 * 関連リンクのデータを生成する
 * @param job 求人詳細レスポンス
 * @returns isVisibleRelationLink 関連リンクのデータ
 */
export const createRelationLinkProps = (
  job: JobDetailResponse | ScoutJobDetailResponse
) => {
  const occupation = {
    label: RELATION_LINK_LABEL.OCCUPATION,
    linkList: createOccupationLinkList(job.searchJobType),
  };
  const area = {
    label: RELATION_LINK_LABEL.AREA,
    linkList: createAreaLinkList(job.area),
  };
  const location = {
    label: RELATION_LINK_LABEL.LOCATION,
    linkList: createLinkList(job.locations, '/'),
  };
  const station = {
    label: RELATION_LINK_LABEL.STATION,
    linkList: createLinkList(job.stations, '/'),
  };
  const industry = {
    label: RELATION_LINK_LABEL.INDUSTRY,
    linkList: createIndustryLinkList(job.industry, job.job?.analysis),
  };
  const isVisibleRelationLink =
    occupation.linkList.list.length ||
    area.linkList.list.length ||
    location.linkList.list.length ||
    station.linkList.list.length ||
    industry.linkList.list.length;

  return {
    isVisibleRelationLink,
    relationLinkProps: {
      occupation,
      area,
      location,
      station,
      industry,
    },
  };
};
